<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="newMode()">{{ t('rooms.create_room') }}</span>
        <span *ngIf="editMode()">{{ t('common.labels.room') }} <strong>{{ room.name }}</strong></span>
      </h1>
    </div>

    <div details>
      <p-tabView>

          <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h">
            <app-room-new *ngIf="newMode()"></app-room-new>
            <app-room-basedata *ngIf="editMode()" [room]="room"></app-room-basedata>
          </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
